(ns practitest.frontend.xbot.db)

(def default-db
  {:current-qm-tab :queue})
